import { lookupSerializer } from '@/providers/serializers/lookup/lookup';
import { http } from '../http';

export class LookupAPI {

    public static INSTACNE = new LookupAPI();

    static get instance() {
        return this.INSTACNE;
    }

    private namespace: string = 'api/nucleus/v1/lookups';

    /**
     * Gets the audience list information
     * @returns {Promise.<[]>}
     */
    public readAudiences() {
        const namespace = this.namespace;
        const url = `${namespace}/audience`;
        const headers = http.getTokenHeaders();
        return http.get(url, headers).then((response) => {
            return lookupSerializer.normalizeReadAudiences(response.data);
        });
    }

    public readLanguages() {
        const namespace = this.namespace;
        const url = `${namespace}/languages`;
        const headers = http.getTokenHeaders();
        return http.get(url, headers).then((response) => {
            return lookupSerializer.normalizeLanguage(response.data);
        });
    }

    public readEducationalUse() {
        const namespace = this.namespace;
        const url = `${namespace}/educational-use`;
        const headers = http.getTokenHeaders();
        return http.get(url, headers).then((response) => {
            return lookupSerializer.normalizeEducationUse(response.data);
        });
    }

    public readDepthOfKnowledge() {
        const namespace = this.namespace;
        const url = `${namespace}/dok`;
        const headers = http.getTokenHeaders();
        return http.get(url, headers).then((response) => {
            return lookupSerializer.normalizeDok(response.data);
        });
    }

    public readLookupFacetData(facetKey: string) {
        const namespace = this.namespace;
        const url = `${namespace}/${facetKey}`;
        const headers = http.getTokenHeaders();
        return http.get(url, headers).then((response) => {
            return lookupSerializer.normalizeDefaultLookup(response.data);
        }).catch(() => {
            return [];
        });
    }
}

export const lookupAPI = LookupAPI.instance;
